<router-outlet *ngIf="displayComponent"></router-outlet>